"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulePanel = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var constants_1 = require("../../constants");
var module_card_1 = require("../module-card");
var sx = {
    paperContainer: {
        borderRadius: '4px',
        maxWidth: '250px',
        minWidth: '144px',
        padding: function (theme) { return "".concat(theme.spacing(1), " 0"); },
        background: function (theme) { return theme.palette.background.paper; },
    },
    listTitle: {
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: 400,
        color: function (theme) { return theme.palette.grey[400]; },
    },
    listItem: {
        padding: function (theme) { return "".concat(theme.spacing(1), " ").concat(theme.spacing(2)); },
    },
    list: {
        padding: '0 !important',
    },
};
var anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
};
var transformOrigin = {
    vertical: 'top',
    horizontal: 'left',
};
var ModulePanel = function (props) {
    var isOpen = props.isOpen, setPopoverClose = props.setPopoverClose, anchorEl = props.anchorEl, modules = props.modules;
    var listTitleSx = __assign(__assign({}, sx.listItem), sx.listTitle);
    var paperProps = {
        sx: sx.paperContainer,
    };
    var moduleCardsElements = modules.map(function (_a) {
        var label = _a.label, link = _a.link;
        return (react_1.default.createElement(module_card_1.ModuleCard, { key: link, label: label, link: link, listItemSx: sx.listItem }));
    });
    return (react_1.default.createElement(material_1.Popover, { open: isOpen, onClose: setPopoverClose, anchorEl: anchorEl, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, PaperProps: paperProps },
        react_1.default.createElement(material_1.Typography, { component: "p", sx: listTitleSx },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "navigation.listTitle", defaultMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u043E\u0434\u0443\u043B\u044C" })),
        react_1.default.createElement(material_1.List, { sx: sx.list, component: "nav", "data-testid": constants_1.ModularNavigationWidgetTestIds.modulePanelList }, moduleCardsElements)));
};
exports.ModulePanel = ModulePanel;
